import type { ReactNode } from 'react';

import { useTranslate } from '@/i18n/use-locale';
import { Toaster } from './toast';

/**
 * The toast stack with a translated dismiss label. Mounted inside `LocaleProvider`
 * so the label follows the locale, and outside the router so a toast survives a
 * route change. The test harness mounts this same component, so a spec sees the
 * label the console shows rather than one it made up.
 */
export function AppToaster({ children }: { children: ReactNode }) {
  const t = useTranslate();
  return <Toaster closeLabel={t('common.dismiss')}>{children}</Toaster>;
}
